import React, {useContext} from 'react';

export const AdminUsersDashboardContext = React.createContext(null);

export const useAdminUsersDashboardContext = () =>  useContext(AdminUsersDashboardContext) ;